
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateCalculationitemSortableRankDtoFormGroup() {
return new FormGroup({
    calculationitemId: new FormControl<number | undefined>(undefined, [Validators.required]),
    calculationitemsGroupId: new FormControl<number | undefined>(undefined, [Validators.required]),
    sortableRank: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      